// extracted by mini-css-extract-plugin
module.exports = {"root":"CreatorSummaryTable_root__x_8eZ"};